const routes = [
    {
        path: "/universities",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "university_index",
        }
    }
];

export default routes;
